import { Types as ServiceTypes } from 'services/genericAPIGatewayService';
import { Action as GlobalAction, State as GlobalState } from 'store';
import { Service } from '../services';

export interface Progress {
  status: 'STARTED' | 'COMPLETE' | 'ERROR';
  newApiKey?: string;
  error?: string;
}

interface MoveState {
  groupId?: string;
  groupName?: string;
  brandId?: string;
  showChangeGroupModal?: boolean;
  showConfirmChangeGroupModal?: boolean;
  showChangeBrandModal?: boolean;
  showConfirmChangeBrandModal?: boolean;
  showGroupDropdown?: boolean;
}

export interface State extends MoveState {
  progress: {
    [id: string]: Progress;
  };
}

const InitialState: State = {
  progress: {},
  showGroupDropdown: false,
  showChangeBrandModal: false,
  showChangeGroupModal: false,
  showConfirmChangeGroupModal: false,
  showConfirmChangeBrandModal: false,
};

enum Types {
  update = 'MoveClient:Update',
  clear = 'MoveClient:Clear',
}

interface UpdateAction {
  type: Types.update;
  payload: MoveState;
}

interface ClearAction {
  type: Types.clear;
}

export type Action = UpdateAction | ClearAction;

export const Actions = {
  update: (payload: MoveState): Action => ({
    type: Types.update,
    payload,
  }),
  clear: (): Action => ({
    type: Types.clear,
  }),
};

export const Selectors = {
  getBrandId: (state: GlobalState): string => state.clients.move.brandId,
  getGroupId: (state: GlobalState): string => state.clients.move.groupId,
  getState: (state: GlobalState): State => state.clients.move,
};

export const reducer = (state: State = InitialState, action: GlobalAction): State => {
  switch (action.type) {
    case Types.update: {
      return {
        ...state,
        ...action.payload,
      };
    }

    case Types.clear: {
      return InitialState;
    }

    case ServiceTypes.CREATE_STARTED: {
      if (action.service === Service.Brands || action.service === Service.Groups) {
        return {
          ...state,
          progress: {
            ...state.progress,
            [action.payload.id]: {
              status: 'STARTED',
            },
          },
        };
      }
      return state;
    }

    case ServiceTypes.CREATE_COMPLETED: {
      if (action.service === Service.Brands || action.service === Service.Groups) {
        return {
          ...state,
          progress: {
            ...state.progress,
            [action.payload.tempId]: {
              status: 'COMPLETE',
              newApiKey: action.payload.id,
            },
          },
        };
      }
      return state;
    }

    case ServiceTypes.CREATE_FAILED: {
      if (action.service === Service.Brands || action.service === Service.Groups) {
        return {
          ...state,
          progress: {
            ...state.progress,
            [action.payload.id]: {
              status: 'ERROR',
              error: action.payload.error,
            },
          },
        };
      }
      return state;
    }

    default: {
      return state;
    }
  }
};
